const init = () => {
    const yotpo = (window as any).yotpoWidgetsContainer;

    if (!yotpo) {
        return null;
    }

    if (yotpo.yotpo_widget_scripts_loaded === false) {
        return false;
    }

    if (yotpo.initWidgets) {
        yotpo.initWidgets();
    }

    return null;
}

export default init;